import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';
import { CircularProgress, Box } from '@mui/material';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { isValidAdminUser } from '../authConfig';

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useIsAuthenticated();
  const { accounts, inProgress } = useMsal();

  // Show loading spinner while authentication is in progress
  if (inProgress === 'startup' || inProgress === 'handleRedirect') {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Check if user is authenticated and from allowed domain
  if (!isAuthenticated || accounts.length === 0) {
    return <Navigate to="/login" replace />;
  }

  const account = accounts[0];
  if (!isValidAdminUser(account.username, account.tenantId)) {
    // User authenticated but not from allowed domain
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
